import React from "react";
import SearchableSelect, {SearchableSelectOption} from "./index";
import {countries} from "../../../constants/countries";
import { noop } from "lodash";


type CountrySelectSingleProps = {
  value?: string | undefined;
  setValue?: (value: string | undefined) => void;
  label?: string;
}

export function CountrySelectSingle ({
    value = "",
    setValue = noop,
    label = "",
                                     }:CountrySelectSingleProps) {

  const componentOptions = countries.map((o) => {
    return {
      value: o.code,
      key: o.code,
      label: o.name,
      search: o.name,
    }
  })


  const selected: SearchableSelectOption<string> | undefined = componentOptions.find(o => o.value === value)

  function handleChange(values: SearchableSelectOption<string>[]) {

    if (values.length == 0) {
      setValue(undefined)
      return
    }

    setValue(values[0].value)
  }

  return <div>
    {label && <label>{label}</label>}
    <SearchableSelect
        label={"Country"}
        multiple={false}
        options={componentOptions}
        selected={selected ? [selected] : []}
        search={true}
        localSearch={true}
        onChange={handleChange}/>
  </div>
}